import React, { useEffect } from "react";
import { Layout } from "@components/layout/Layout";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


export const Cookie_Policy = () => {
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 3) {
        document.body.classList.add("show-scroll-btn");
      } else {
        document.body.classList.remove("show-scroll-btn");
      }
    };
    const handleClick = () => {
      document.body.classList.toggle("hidden");
      document.documentElement.classList.toggle("hidden");
    };

    const checkMenu = document.getElementById("check-menu");
    if (checkMenu) {
      checkMenu.addEventListener("click", handleClick);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (checkMenu) {
        checkMenu.removeEventListener("click", handleClick);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("main-page");
    return () => {
      document.body.classList?.remove("main-page");
    };
  }, []);

  return (
    <Layout>
      <div className="basic-main">
        <div className="container">
          <h1>Cookie Policy</h1>
          <div className="section">
          <p>This Cookie Policy explains how Cronika ("we", "our", or "us") uses cookies and similar technologies to recognize you when you visit our website at <a href="https://cronika.com/" target="_blank">https://cronika.com/</a>. It explains what these technologies are, why we use them, and your rights to control their use.</p>

          <h3>1. What Are Cookies?</h3>
          <p>Cookies are small text files that are stored on your device (computer, tablet, smartphone) when you visit a website. They help websites function properly, enhance user experience, and provide information to website owners for analytics and performance improvements.</p>

          <h3>2. Why We Use Cookies</h3>
          <p>We use cookies for several reasons:</p>

            <p><strong>Essential Cookies:</strong> These are necessary for the operation of our Website. They enable core functionality such as security, network management, and accessibility.</p>
            <p><strong>Performance & Analytics Cookies:</strong> These help us understand how visitors interact with the Website by collecting information anonymously to improve our services.</p>
            <p><strong>Functionality Cookies:</strong> These remember your preferences and choices to provide a more personalized experience.</p>
            <p><strong>Marketing Cookies:</strong> These are used to deliver relevant ads and track the effectiveness of our advertising campaigns.</p>


          <h3>3. Types of Cookies We Use</h3>
          <table style={{ width: '100%' }}>
            <thead style={{ textAlign: "left" }}>
              <tr>
                <th><p>Type</p></th>
                <th><p>Purpose</p></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><p>Session Cookies</p></td>
                <td><p>Temporary cookies that expire once you close your browser.</p></td>
              </tr>
              <tr>
                <td><p>Persistent Cookies</p></td>
                <td><p>Stay on your device for a set period or until you delete them.</p></td>
              </tr>
              <tr>
                <td><p>First-party Cookies</p></td>
                <td><p>Set directly by <a href="https://cronika.com/" target="_blank">https://cronika.com/</a></p></td>
              </tr>
              <tr>
                <td><p>Third-party Cookies</p></td>
                <td><p>Set by services we use (e.g., Google Analytics, advertising platforms).</p></td>
              </tr>
            </tbody>
          </table>

          <h3>4. Your Choices and Controls</h3>
          <p>When you first visit our Website, you will be presented with a cookie banner asking for your consent to use non-essential cookies. You can accept or reject them.</p>
          <p>You can also manage or disable cookies via your browser settings. However, disabling certain cookies may affect the functionality and performance of our Website.</p>
          <p>For more information on how to manage cookies in your browser, you may visit:</p>

            <p><a href="https://support.google.com/chrome/answer/95647" target="_blank">Google Chrome</a></p>
            <p><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" target="_blank">Mozilla Firefox</a></p>
            <p><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank">Safari</a></p>
            <p><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank">Microsoft Edge</a></p>

          <h3>5. Updates to This Cookie Policy</h3>
          <p>We may update this Cookie Policy from time to time. When we do, we will revise the “Effective Date” at the top of this page. We encourage you to review this page regularly to stay informed about our use of cookies.</p>

          <h3>6. Contact Us</h3>
          <p>If you have any questions about our use of cookies or this Cookie Policy, please contact us at:</p>
          <p>📧 support@cronika.com</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Cookie_Policy;
